export default __webpack_public_path__ + "static/media/tooltip_link.c6495e78.svg";